import { ReactComponent as SvgChevronDown } from '@img/icons/chevron-down.svg';
import LinkButton from '@stories/Components/Buttons/LinkButton/LinkButton';
import * as React from 'react';
import FS from '../Shared/FooterShared.styles';
import S from './FooterLinks.styles';
const FooterLinks = ({ cta, items, title }) => {
    const [isOpened, setIsOpened] = React.useState(false);
    return (React.createElement(S.Container, { initial: "closed", animate: isOpened ? 'opened' : 'closed' },
        title && (React.createElement(FS.Title, { onClick: () => {
                setIsOpened(!isOpened);
            } },
            title,
            React.createElement(FS.TitleIconWrapper, { variants: {
                    closed: { rotate: 0 },
                    opened: { rotate: 180 },
                } },
                React.createElement(FS.TitleIcon, { as: SvgChevronDown })))),
        React.createElement(S.List, { variants: {
                closed: { height: 0 },
                opened: { height: 'auto' },
            } }, items.map((item) => (React.createElement(S.Item, { key: item.id },
            React.createElement(S.Link, { href: item.url, target: item.target, "aria-label": item.accessibleText }, item.text))))),
        cta?.text && (React.createElement(LinkButton, { themeOption: "brownOutline", href: cta.url, target: cta.target, title: cta.text, "aria-label": cta.accessibleText }))));
};
export default FooterLinks;
